module.exports = __webpack_public_path__ + "static/media/image_17.021cdc55.png";